import React from 'react'

import { useIsSmallDevice } from '../../hookreducer/hooks'

import __ from '../../languages/parser'

import {
  STEP_BOARD_URL, STEP_BOARDS_DIMENSIONS_URL, STEP_WALL_BASES_URL, ACCESSORIES_URL,
} from '../../static/url'

export const StyleInfos = () => (
  <>{__('content_style')}</>
)

export const BoardsInfos = () => {
  const isSmall = useIsSmallDevice()
  return (
    <div>
      {__('content_boards')}
      <div style={{ textAlign: 'center' }}>
        <img src={STEP_BOARD_URL} style={{ width: isSmall ? '100%' : '40%' }} alt="" />
        <img src={STEP_BOARDS_DIMENSIONS_URL} style={{ width: isSmall ? '100%' : '60%' }} alt="" />

      </div>
    </div>
  )
}

export const WallBasesInfos = () => {
  const isSmall = useIsSmallDevice()
  return (
    <>
      {__('content_wall_bases')}
      <div style={{ textAlign: 'center' }}>
        <img src={STEP_WALL_BASES_URL} style={{ width: isSmall ? '100%' : '80%' }} alt="" />
      </div>
    </>
  )
}

export const AccessoriesInfos = () => (
  <>
    <div style={{ textAlign: 'center' }}>
      <img src={ACCESSORIES_URL[__('languageCode')]} alt="accessoires Gassien Paris" style={{ width: '80%' }} />
    </div>
  </>
)

export const DecorInfos = () => (
  <>
    <div style={{ textAlign: 'center' }}>
      {__('deco_style')}
    </div>
  </>
)
